export const topbar = {
  searchPlaceholder: 'Search tasks, records, templates...',
  profile: 'Profile',
  settings: 'Settings',
  logout: 'Logout',
};
